import { render, staticRenderFns } from "./ComplaintsReportPage.vue?vue&type=template&id=5973be90&scoped=true&"
import script from "./ComplaintsReportPage.vue?vue&type=script&lang=js&"
export * from "./ComplaintsReportPage.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsReportPage.vue?vue&type=style&index=0&id=5973be90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973be90",
  null
  
)

export default component.exports